module.exports = __webpack_public_path__ + "img/lx.5234869f.png";